import { render } from "./ModalSuggestIdea.vue?vue&type=template&id=1c1deadd&scoped=true"
import script from "./ModalSuggestIdea.vue?vue&type=script&lang=js"
export * from "./ModalSuggestIdea.vue?vue&type=script&lang=js"

import "./ModalSuggestIdea.vue?vue&type=style&index=0&id=1c1deadd&scoped=true&lang=css"

import exportComponent from "/vhost/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1deadd"]])

export default __exports__